import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { RouterBaseService } from '../router/router-base.service';
import { DataAnalyticsEvent, DataAnalyticsInitialData, DataAnalyticsModalData } from './data-analytics.domain';

import type { ModalRef } from '../../components/modal/modal-ref';

@Injectable({
  providedIn: 'root'
})
export class DataAnalyticsService {
  private readonly routerService = inject<RouterBaseService>(RouterBaseService);

  dataAnalyticsEvent: Subject<DataAnalyticsEvent> = new Subject<DataAnalyticsEvent>();
  dataAnalyticsEvents: Array<DataAnalyticsEvent> = [];
  private hasSentBaseEvent: boolean = false;
  private initData?: DataAnalyticsInitialData;

  init(initData: DataAnalyticsInitialData): void {
    this.initData = initData;
    this.routerService.setDataAnalyticsHooks?.(this.initData)
      ?.subscribe((event: DataAnalyticsEvent) => this.emitEvent(event));
  }

  registerModalEvents(modalRef: ModalRef<unknown>, modaData: DataAnalyticsModalData): void {
    const modalOpenEvent: DataAnalyticsEvent = modaData?.dataAnlyticsEvent;
    const modalCloseEvent = this.initData?.modalCloseEvent;

    if(modalOpenEvent) {
      this.emitEvent(modalOpenEvent);

      if(modalCloseEvent) {
        const modalCloseSubscription = modalRef.afterClose().subscribe((): void => {
          this.emitEvent(modalCloseEvent);
          modalCloseSubscription.unsubscribe();
        });
      }
    }
  }

  emitEvent(event: DataAnalyticsEvent): void {
    let newEvent = { ...event };

    if(!this.hasSentBaseEvent) {
      newEvent = { ...this.initData?.baseEvent, ...newEvent };
      this.hasSentBaseEvent = true;
    }

    this.dataAnalyticsEvent.next(newEvent);
    this.dataAnalyticsEvents.push(newEvent);
  }

  emitLinkClickEvent(eventName: string, type: string = 'link', data?: Record<string, unknown>): void {
    const name = this.prefixEventName(eventName);
    this.emitEvent({
      event: 'linkClick',
      link: {
        name,
        type,
        ...data
      }
    });
  }

  prefixEventName(eventName: string): string {
    const eventNamePrefix = this.initData?.eventNamePrefix;
    if (eventNamePrefix !== undefined && !eventName.startsWith(eventNamePrefix)) {
      eventName = `${eventNamePrefix}:${eventName}`;
    }
    return eventName;
  }
}
